<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeadersUnidadesDeNegocios"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        :max-width="maxWidth[0]"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :itemsSelect="dataSelects"
          :itemsCheckbox="dataCheckboxes"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :showDate="true"
          :showCheck="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
        :maxWidth="maxWidth[1]"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import date from "@/store/common/date";
import operators from "../../../../store/operadores/operators";
import BusinessUnits from "../../../../models/operadores/relations/BusinessUnits";
import businessUnits from "../../../../store/unidadesDeNegocios/businessUnits";
import moment from "moment";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("operators.business"),
      titleTable: "Operadores_y_Relaciones",
      titleDelete: this.$tc("operators.deleteBusinessToRelation"),
      isLoading: true,
      nameOper: "",
      maxWidth: ["580px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "dateStart",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "dateEnd",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Por defecto",
          value: "isDefaultTable",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      dataCheckboxes: [
        {
          name: "def",
          label: "Unidad de Negocio por defecto",
          data: true,
        },
      ],
      negocios: [
        { id: 1, name: "General" },
        { id: 2, name: "NuevaUN" },
      ],
    };
  },
  computed: {
    allHeaders() {
      return configTable.state.colums.unidadesDeNegocios;
    },
    items() {
      if (
        !operators.state.edit.unnegocios ||
        operators.state.edit.unnegocios.length === 0
      ) {
        return [];
      }
      return operators.state.edit.unnegocios.map((item) => {
        return BusinessUnits.fromJson(item);
      });
    },
    businessUnits() {
      return businessUnits.state.businessUnits;
    },

    dataSelects() {
      return [
        {
          name: "unNegocioId",
          label: "Negocios",
          data: "",
          items: [],
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false,
        },
      ];
    },

    mode: {
      get() {
        return operators.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return operators.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return operators.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  async mounted() {
    operators.dispatch("getOperators");
    businessUnits.dispatch("getBusinessUnits");
    this.isLoading = false;
  },
  methods: {
    async refreshItems() {
      await operators.dispatch("getOperatorId", operators.state.idOper);
    },
    updateHeadersUnidadesDeNegocios(headers) {
      const updatedColums = {
        ...configTable.state.colums,
        unidadesDeNegocios: headers,
      };
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    addBusiness(form) {
      let payload = form;
      payload.fecAlta = date.state.dateFrom + "T00:00:00.000Z";
      if (date.state.dateTo !== null) {
        payload.fecBaja = date.state.dateTo + "T00:00:00.000Z";
      }
      if (form.def === "true") {
        payload.def = form.def;
        this.showAlert(
          this.$tc(
            "La fecha hasta, siempre sera no expira cuando es la Unidad de Negocios por defecto"
          ),
          "#82A1D0"
        );
      }

      payload.def = form.def === "true";
      payload.unNegocioId = Number(form.unNegocioId);
      payload.operId = operators.state.edit.operId;
      let business = businessUnits.state.businessUnits.filter(
        (buss) => buss.id == payload.unNegocioId
      );
      payload.name = business[0].name;

      operators.commit("setNew", payload);
      operators
        .dispatch("addBusinessUnitsToOperator")
        .then(() => {
          this.showAlert(this.$tc("operators.addBusinessSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
          reject(e);
        });
      this.reset(false);
    },

    editBusiness(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        (payload.operId = operators.state.edit.operId),
          (payload.unNegocioId = Number(form.unNegocioId));
        operators.commit("setEditRelation", payload);
        operators
          .dispatch("editBusinessUnitsToOperator")
          .then(() => {
            this.showAlert(
              this.$tc("operators.editBusinessSuccess"),
              "#82A1D0"
            );
          })
          .catch((e) => {
            this.showAlert(e.response.data.error.message, "#FF8D58");
            reject(error);
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },
    detectChanges(newItems) {
      newItems.dateStartInput = date.state.dateFrom;
      newItems.dateEndInput = date.state.dateTo;
      newItems.def = newItems.def === "true";

      const changes = {};
      const oldItem = this.oldItems;

      if (oldItem) {
        if (oldItem.dateStartInput !== newItems.dateStartInput) {
          changes.dateStartInput = newItems.dateStartInput;
        }

        if (oldItem.dateEndInput !== newItems.dateEndInput) {
          changes.dateEndInput = newItems.dateEndInput;
        }
        if (oldItem.def !== newItems.def) {
          changes.def = newItems.def;
        }
      }

      return changes;
    },

    async openDialog(type, item) {
      this.resetDate();
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          this.dataSelects[0].items = this.businessUnits;
          this.dataSelects[0].readonly = false;
          date.state.checkTo = true;
          operators.commit(
            "setModeFormRelation",
            this.$tc("operators.addBusinessToRelation")
          );
          operators.commit("setOpenFormRelation", true);
          break;
        case "edit":
          this.dataSelects[0].items = this.businessUnits;
          this.dataSelects[0].readonly = true;
          this.oldItems = item;
          this.itemId = item.id;
          await this.setEdit(item);
          operators.commit(
            "setModeFormRelation",
            this.$tc("operators.editBusinessToRelation")
          );
          operators.commit("setOpenFormRelation", true);
          break;
        case "delete":
          operators.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            operId: operators.state.edit.operId,
          };

          break;

        default:
          break;
      }
    },

    setEdit(item) {
      date.state.dateFrom = item.dateStartInput;
      if (item.dateEndInput !== null) {
        date.state.dateTo = item.dateEndInput;
        date.state.checkTo = false;
      } else {
        date.state.checkTo = true;
      }
      this.dataSelects[0];
      this.dataSelects[0].data = item.id;
      this.dataCheckboxes[0].data = item.isDefaultBool;

      this.showAlert(
        this.$tc(
          "La fecha hasta siempre sera no expira cuando es la Unidad de Negocios por defecto"
        ),
        "#82A1D0"
      );
    },

    resetDate() {
      const today = moment().format("YYYY-MM-DD");
      date.commit("setDateFrom", today);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      operators.commit("setOpenFormRelation", value);
      this.dataSelects.forEach((item) => {
        item.data = "";
      });
      this.dataCheckboxes.forEach((item) => {
        item.data = "";
      });
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addBusiness(items);
          break;
        case "edit":
          this.editBusiness(items);
          break;
        default:
          break;
      }
    },

    deleteItem() {
      operators.commit("setItemDelete", this.itemToDelete);
      operators
        .dispatch("deleteBusinessUnitsToOperator")
        .then(() => {
          this.openDelete = false;
          operators.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("operators.deleteBusinessSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.showAlert(e.response.data.error.message, "#FF8D58"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      operators.commit("setOpenDelete", false);
    },
  },
};
</script>
